/**
 * The id of the scan whose values the customer last saved (pressed Continue with), kept for the
 * tab's session so it survives a reload. The saved identity document carries no scan id, so
 * without this a step that mounts again cannot tell the re-poll of the saved scan from the poll
 * of a newer one (verifime-adr#791).
 *
 * The key names the customer and the document type, so two customers or two documents in one tab
 * never share an id. Storage is a courtesy: when it refuses a read or a write, the step falls back
 * to the empty-form rule (a scan body fills an empty form only), and the warning has fixed text.
 * Both functions run from event handlers, never while rendering on the server.
 */
const savedScanIdKey = (customerId: string, documentType: string) =>
  `identityDocumentSavedScanId:${customerId}:${documentType}`;

export function getSavedScanId(customerId: string, documentType: string): string | null {
  try {
    return sessionStorage.getItem(savedScanIdKey(customerId, documentType));
  } catch {
    console.warn('Identity document: the saved scan id could not be read');
    return null;
  }
}

/** Remembers the scan the saved value belongs to; null (a value saved with no scan) forgets it. */
export function rememberSavedScanId(
  customerId: string,
  documentType: string,
  scanId: string | null,
): void {
  try {
    const key = savedScanIdKey(customerId, documentType);
    if (scanId) {
      sessionStorage.setItem(key, scanId);
    } else {
      sessionStorage.removeItem(key);
    }
  } catch {
    console.warn('Identity document: the saved scan id could not be kept');
  }
}
